import React, { createContext, useCallback, useContext, useEffect, useRef, useState } from 'react';
import { CircleCheck } from 'lucide-react';

const Ctx = createContext(() => {});
export const useToast = () => useContext(Ctx);

export function ToastProvider({ children }) {
  const [msg, setMsg] = useState(null);
  const t = useRef();
  const flash = useCallback((m) => { clearTimeout(t.current); setMsg(m); t.current = setTimeout(() => setMsg(null), 2600); }, []);
  useEffect(() => () => clearTimeout(t.current), []);
  return (
    <Ctx.Provider value={flash}>
      {children}
      {msg && <div className="km-toast" role="status"><CircleCheck size={16} color="#22c55e" />{msg}</div>}
    </Ctx.Provider>
  );
}

export function Toggle({ on, onChange, small }) {
  return <button type="button" role="switch" aria-checked={on} className={`km-toggle ${on ? 'on' : ''} ${small ? 'sm' : ''}`} onClick={onChange}><span /></button>;
}

export function Segment({ options, value, onChange }) {
  return <div className="km-segment">{options.map(([v, label]) => <button key={v} type="button" className={v === value ? 'on' : ''} onClick={() => onChange(v)}>{label}</button>)}</div>;
}

export function SettingRow({ title, sub, children }) {
  return <div className="km-row"><div><div className="km-row-title">{title}</div>{sub && <div className="km-row-sub">{sub}</div>}</div>{children}</div>;
}

export function Avatar({ name = '', size = 34, style }) {
  const i = name.split(' ').map((w) => w[0]).slice(0, 2).join('').toUpperCase();
  return <span className="km-avatar" style={{ width: size, height: size, fontSize: size * .36, ...style }}>{i}</span>;
}

export function Modal({ onClose, width = 680, children }) {
  useEffect(() => { const k = (e) => e.key === 'Escape' && onClose(); window.addEventListener('keydown', k); return () => window.removeEventListener('keydown', k); }, [onClose]);
  return <div className="km-modal-backdrop" onClick={onClose}><div className="km-modal" style={{ width }} onClick={(e) => e.stopPropagation()}>{children}</div></div>;
}

export function PasswordStrength({ score, pw }) {
  const colors = ['var(--km-line2)', 'var(--km-bad)', 'var(--km-warn)', 'var(--km-ok)', 'var(--km-ok)'];
  return <div className="km-pw-bars"><div>{[1, 2, 3, 4].map((i) => <i key={i} style={{ background: i <= score ? colors[score] : undefined }} />)}</div><small style={{ color: colors[score] }}>{pw ? ['', 'Weak', 'Fair', 'Strong', 'Very strong'][score] : ''}</small></div>;
}

export function Wordmark({ size = 17 }) {
  return <span style={{ fontSize: size, letterSpacing: '-.02em' }}><span style={{ fontWeight: 700 }}>krypta</span><span style={{ fontWeight: 500, color: 'var(--km-accent)' }}>mail</span></span>;
}

export const LABEL_COLORS = { Work: 'var(--km-label-work)', Legal: 'var(--km-label-legal)', Ops: 'var(--km-label-ops)' };
export function LabelPill({ name }) {
  const c = LABEL_COLORS[name] || 'var(--km-muted)';
  return <span className="km-pill" style={{ background: `color-mix(in srgb, ${c} 16%, transparent)`, color: c }}>{name}</span>;
}
